const INITIAL_STATE = {
  showMenu: true,
  minimizeMenu: true,
  menu: [],
  routes: [],
  logged: false,
  tryLogin: false,
  active_roles: {},
  layout: true,
  roleMenu: [],
  userRoutes: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MENU_STRUCTURE":
      return { ...state, menu: action.payload };
    case "ROUTES_STRUCTURE":
      return { ...state, routes: action.payload };
    case "ACTIVE_ROLES":
      return { ...state, active_roles: action.payload };
    case "TRANSLATES":
      return { ...state, translates: action.payload };
    case "LOGIN_ACT":
      return { ...state, logged: action.payload };
    case "LOGOFF_ACT":
      return { ...state, logged: action.payload };
    case "SET_GROUP":
      return {
        ...state,
        active_roles: { ...state.active_roles, group_id: action.payload }
      };
    case "FILTERED_CONTENT":
      return { ...state, filtered_content: action.payload };
    case "TOGGLE_MENU":
      return {
        ...state,
        showMenu: [false, "responsive"].includes(state.showMenu)
          ? true
          : "responsive"
      };
    case "SET_MENU":
      return { ...state, showMenu: action.payload };
    case "TOGGLE_MINIMIZE_MENU":
      return { ...state, minimizeMenu: !state.minimizeMenu };
    case "SET_MINIMIZE_MENU":
      return { ...state, minimizeMenu: action.payload };
    case "TRY_LOGIN":
      return { ...state, tryLogin: action.payload };
    case "SET_LAYOUT":
      return { ...state, layout: action.payload };
    case "SET_ROLE_MENU":
      return { ...state, roleMenu: action.payload };
    case "USER_ROUTES":
      return {
        ...state,
        userRoutes: [...action.payload] // 🔥 isso cria uma nova referência
      };
    default:
      return state;
  }
};
